import { render, staticRenderFns } from "./peixun-history.vue?vue&type=template&id=7a764077&scoped=true"
import script from "./peixun-history.vue?vue&type=script&lang=js"
export * from "./peixun-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a764077",
  null
  
)

export default component.exports